import { WEBUILogs } from "../logging";
import weekData from "./weekData";

export default function(locale = "en-US") {
    let countryCode = "US";
    if (locale.length < 5) {
        WEBUILogs.warn(
            "getLocaleWeekFirstDayNumber: Your locale must specify a country! US will be used as default."
        );
    } else {
        countryCode = locale.substr(locale.indexOf("-") + 1, 2);
    }
    if (weekData.firstDay[countryCode] !== 0 && !weekData.firstDay[countryCode]) {
        WEBUILogs.error("getLocaleWeekFirstDayNumber: Unknown locale country used!");
    } else {
        return weekData.firstDay[countryCode];
    }
}
